<template>
  <div class="physioCategoryManage">
    <div class="header">
      <el-tabs class="header_tabs" v-model="active" type="card">
        <el-tab-pane label="项目分类" name="physioCategory"></el-tab-pane>
        <el-tab-pane label="可同时执行组合" name="physioParallelCombination"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="content">
      <component :is="componentsMap[active]"></component>
    </div>
  </div>
</template>

<script>
  import PhysioCategory from './components/physioCategory.vue'
  import PhysioParallelCombination from './components/physioParallelCombination.vue'

  export default {
    name: 'physioCategoryManage',
    components: {
      PhysioCategory,
      PhysioParallelCombination
    },
    data () {
      return {
        active: 'physioCategory',
        componentsMap: {
          'physioCategory': PhysioCategory,
          'physioParallelCombination': PhysioParallelCombination
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .physioCategoryManage {
    box-sizing: border-box;
    padding: 20px;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .header {
    width: 100%;
    height: 36px;
  }

  .header_tabs {
    margin: 0 0 0 0 !important;
    height: 36px;
    border: none;
  }

  .header_tabs /deep/ .el-tabs__header {
    box-sizing: border-box;
    margin: 0 0 0 0 !important;
    padding: 0px;
    border-bottom: 1px solid #E0E0E0;
  }

  .header_tabs /deep/ .el-tabs__nav-wrap {
    margin: 0 0 0 0;
  }

  .header_tabs /deep/ .el-tabs__item {
    height: 34px;
    line-height: 34px;
    font-weight: 400;
  }

  .header_tabs /deep/ .el-tabs__item.is-active {
    color: #FFFFFF;
    background-color: #1890FF;
    border-bottom-color: #1890FF;
  }

  .content {
    width: 100%;
    margin: 20px 0 0 0;
    height: calc(100% - 36px - 20px);
    overflow: hidden;
  }
</style>